Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllConnectionIds = exports.removeConnectionId = exports.addConnectionId = void 0;
const CACHE_KEY = 'henderson-signalr-connectionids';
function addConnectionId(connectionId) {
    getConnectionIdCache().add(connectionId);
}
exports.addConnectionId = addConnectionId;
function removeConnectionId(connectionId) {
    getConnectionIdCache().delete(connectionId);
}
exports.removeConnectionId = removeConnectionId;
function getAllConnectionIds() {
    return [...getConnectionIdCache()];
}
exports.getAllConnectionIds = getAllConnectionIds;
function getConnectionIdCache() {
    let connectionIds = window[CACHE_KEY];
    if (!connectionIds) {
        connectionIds = new Set();
        window[CACHE_KEY] = connectionIds;
    }
    return connectionIds;
}
//# sourceMappingURL=signalRConnectionIdsCache.js.map